import Vue from 'vue';
import VueI18n from 'vue-i18n';

import '../common/errorHandler';
import store from '../common/vuex';
import '../common/vTools';

// components
import login from './login.vue';

Vue.use(VueI18n);
Vue.config.productionTip = false;

// start application
store.dispatch('fetchState', 'configs')
  .then(() => {
    new Vue({
      i18n: new VueI18n({ locale: document.documentElement.lang }),
      el: '#login',
      store,
      components: {
        login,
      },
    });
  });
